// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo[data-v-8d90065a]{transform:scaleY(.96) rotate(-2.5deg)}.logo[data-v-8d90065a],.logo__main[data-v-8d90065a]{position:relative;width:-moz-fit-content;width:fit-content}.logo__main[data-v-8d90065a]{padding:4px 8px}.logo__subtitle[data-v-8d90065a]{padding:4px 8px;position:relative;transform:translateX(5%) translateY(-5px) scale(.95)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
